<template>
  <v-col cols="12" md="6" class="asc-mxrec-conclude-wrapper form-wrapper">
    <h3 class="subtitle">Conclude</h3>
    <asc-text-field-input
      v-model="getMroLocation"
      label="MRO Location"
      :max-length="textFieldMaxLength"
      update-on-blur
      :disabled="reEntrantLock"
      :readonly="isReadOnlyPermissionInvestigate && !isRecommendationTab"
    />
    <asc-text-field-input
      v-model="getMroPoc"
      label="MRO POC"
      :max-length="textFieldMaxLength"
      update-on-blur
      :disabled="reEntrantLock"
      :readonly="isReadOnlyPermissionInvestigate && !isRecommendationTab"
    />
    <asc-autocomplete-selector
      v-model="getReasonForClosing"
      :disabled="reEntrantLock"
      :items="reasonToCloseOptions"
      label="Reason for Closing the Issue"
      no-array
      display-clear
      :readonly="isReadOnlyPermissionInvestigate && !isRecommendationTab"
      :sort-items="false"
    />
    <asc-date-picker
      v-model="getRemovalDate"
      label="Date of Removal"
      format="DD MMM YYYY"
      icon-position="right"
      :disabled="
        reEntrantLock ||
        (isReadOnlyPermissionInvestigate && !isRecommendationTab)
      "
      :readonly="isReadOnlyPermissionInvestigate"
    />
  </v-col>
</template>

<script>
import AscAutocompleteSelector from '@/components/molecules/AscAutocompleteSelector'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'
import AscDatePicker from '@/components/atoms/AscDatePicker'
import {
  AscMxRecPropsMixin,
  AscMxRecPermissionMixin,
} from '@/components/mixins'
import { debounceShortTime } from '@/utilities/appConsts'
import _ from 'lodash'

export default {
  name: 'AscMxRecConcludeWrapper',

  components: {
    AscAutocompleteSelector,
    AscTextFieldInput,
    AscDatePicker,
  },

  mixins: [AscMxRecPropsMixin, AscMxRecPermissionMixin],

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    reasonToCloseOptions: {
      type: Array,
      default: () => [],
    },
    reEntrantLock: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      textFieldMaxLength: 100,
    }
  },

  computed: {
    getReasonForClosing: {
      get() {
        return this.data.reasonToCloseId
      },
      set(val) {
        this.emitChangeEvent({
          reasonToCloseId: val,
        })
      },
    },
    getRemovalDate: {
      get() {
        return this.data.removalDate
      },
      set(val) {
        if (val && val?.dates?.startDate) {
          this.emitChangeEvent({
            removalDate: val.dates.startDate,
          })
        }
      },
    },
    getMroPoc: {
      get() {
        return this.data.mroPOC
      },
      set(val) {
        this.emitChangeEvent({
          mroPOC: val,
        })
      },
    },
    getMroLocation: {
      get() {
        return this.data.mroLocation
      },
      set(val) {
        this.emitChangeEvent({
          mroLocation: val,
        })
      },
    },
  },

  methods: {
    emitChangeEvent(propToOverwrite) {
      const mergedInfo = {
        ...this.data,
        ...propToOverwrite,
      }
      this.$emit('updateConcludeInfo', mergedInfo)
    },
    debounceInput: _.debounce(function (e) {
      this.model = e
    }, debounceShortTime),
  },
}
</script>

<style lang="scss">
.asc-mxrec-conclude-wrapper {
  display: flex;
  flex-direction: column;

  &.form-wrapper {
    .asc-autocomplete-selector {
      margin-bottom: 21px;

      .asc-base-selector--label {
        height: 12px;
        margin-top: 4px;

        .asc-required-label {
          line-height: 12px;
        }
      }

      .asc-base-selector--input-container {
        height: 32px !important;
        padding: 8px 0 8px;
        align-items: center;

        .asc-base-selector--input {
          height: 24px;
        }
      }
    }
  }

  .subtitle {
    font-size: $font-size-md;
    line-height: $line-height-md;
    color: $primary-black;
    letter-spacing: 1px;
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 29px;
  }
}
</style>
